import anime from 'animejs/lib/anime.es.js';
import { inViewport } from '../../utils/inViewport';
import PatternGridIcon from '../../../svg/pattern-grid.svg';
import CrossIcon from '../../../svg/cross.svg';
import PatternGridShortIcon from '../../../svg/pattern-grid-short.svg';
import PatternGridLongIcon from '../../../svg/pattern-grid-long.svg';

/**
 * Class definition for `wp-pattern-grid` element
 *
 * @class WPPatternGrid
 * @extends {HTMLElement}
 */
class WPPatternGrid extends HTMLElement {
  constructor(self) {
    self = super(self);
    this.observer = null;
    return self;
  }

  /**
   * Tag name of element
   *
   * @readonly
   * @static
   */
  static get is() {
    return 'wp-pattern-grid';
  }

  get icon() {
    return this.getAttribute('icon');
  }

  get shapes() {
    return this.querySelectorAll('g');
  }

  get paths() {
    return this.querySelectorAll('path');
  }

  get loop() {
    return this.hasAttribute('loop') ? this.hasAttribute('loop') : false;
  }

  get template() {
    let shapeSvg;

    switch (this.icon) {
      case 'pattern-grid':
        shapeSvg = PatternGridIcon;
        break;
      case 'cross':
        shapeSvg = CrossIcon;
        break;
      case 'pattern-grid-short':
        shapeSvg = PatternGridShortIcon;
        break;
      case 'pattern-grid-long':
        shapeSvg = PatternGridLongIcon;
        break;
    }

    if (shapeSvg) {
      return `<i class="icon-${this.icon}">${shapeSvg}</i>`;
    }

    return `
      <i class="icon-${this.icon}">
        <svg aria-hidden="true">
          <use xlink:href="/wp-content/themes/genv/static/dist/svg/symbols.svg#${this.icon}" />
        </svg>
      </i>
    `;
  }

  connectedCallback() {
    if (!this.icon) {
      console.log('No icon defined');
      return;
    }

    this.classList.add('c-pattern-grid');
    this.setAttribute('data-sal', '');
    this.innerHTML = this.template;

    if (inViewport(this)) {
      // Hack: Gulpicon doesn't seem to have events on individual items
      setTimeout(() => {
        this._animate();
      }, 1000);
    } else {
      this.addEventListener('sal:in', ({ detail }) => {
        this._animate();
      });
    }
  }

  _animate() {
    anime({
      targets: this.shapes,
      opacity: 1,
      duration: this.loop ? 1000 : 1500,
      easing: 'linear',
      loop: this.loop,
      direction: this.loop ? 'alternate' : 'normal',
      delay: (el, index, length) => {
        return anime.random(0, 10) * 100;
      },
    });
  }
}

customElements.define(WPPatternGrid.is, WPPatternGrid);
